import React from 'react'

export const MeSvg = () => (
  <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.18849 2.0863C5.53103 1.41935 6.21782 1 6.96758 1H29C30.1046 1 31 1.89543 31 3V17C31 18.1046 30.1046 19 29 19H6.96758C6.21781 19 5.53103 18.5807 5.18849 17.9137L1.59343 10.9137C1.29888 10.3402 1.29888 9.65982 1.59343 9.0863L5.18849 2.0863Z" fill="#6AAF68" stroke="#6AAF68" strokeWidth="2"/>
    <path d="M12.0586 5.46875L14.25 11.6562L16.4297 5.46875H18.7383V14H16.9746V11.668L17.1504 7.64258L14.8477 14H13.6406L11.3438 7.64844L11.5195 11.668V14H9.76172V5.46875H12.0586ZM25.4062 10.3027H22.0312V12.5879H25.9922V14H20.2734V5.46875H25.9805V6.89258H22.0312V8.92578H25.4062V10.3027Z" fill="white"/>
  </svg>
)
